import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';

function CpanelDashboard() {
  return (
    <div className="cpanel-dashboard">
      <h2 className="mb-4">Tableau de bord</h2>
      
      <Row className="mb-4">
        <Col md={4}>
          <Card className="dashboard-card">
            <Card.Body>
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h6 className="text-muted mb-1">Événements actifs</h6>
                  <h3 className="mb-0">12</h3>
                </div>
                <div className="dashboard-icon bg-light-danger">
                  <i className="fas fa-calendar-alt text-danger"></i>
                </div>
              </div>
              <div className="mt-3">
                <span className="text-success">
                  <i className="fas fa-arrow-up me-1"></i>8%
                </span>
                <span className="text-muted ms-2">Depuis le mois dernier</span>
              </div>
            </Card.Body>
          </Card>
        </Col>
        
        <Col md={4}>
          <Card className="dashboard-card">
            <Card.Body>
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h6 className="text-muted mb-1">Réservations</h6>
                  <h3 className="mb-0">284</h3>
                </div>
                <div className="dashboard-icon bg-light-primary">
                  <i className="fas fa-ticket-alt text-primary"></i>
                </div>
              </div>
              <div className="mt-3">
                <span className="text-success">
                  <i className="fas fa-arrow-up me-1"></i>12%
                </span>
                <span className="text-muted ms-2">Depuis le mois dernier</span>
              </div>
            </Card.Body>
          </Card>
        </Col>
        
        <Col md={4}>
          <Card className="dashboard-card">
            <Card.Body>
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h6 className="text-muted mb-1">Revenus</h6>
                  <h3 className="mb-0">9,840 €</h3>
                </div>
                <div className="dashboard-icon bg-light-success">
                  <i className="fas fa-euro-sign text-success"></i>
                </div>
              </div>
              <div className="mt-3">
                <span className="text-danger">
                  <i className="fas fa-arrow-down me-1"></i>3%
                </span>
                <span className="text-muted ms-2">Depuis le mois dernier</span>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      
      <Row>
        <Col md={8}>
          <Card className="mb-4">
            <Card.Header className="bg-white">
              <h5 className="mb-0">Événements à venir</h5>
            </Card.Header>
            <Card.Body>
              <div className="upcoming-event d-flex align-items-center p-3 border-bottom">
                <div className="event-date me-3 text-center">
                  <div className="date-day">15</div>
                  <div className="date-month">Avr</div>
                </div>
                <div className="event-details flex-grow-1">
                  <h6 className="mb-1">Concert de Jazz</h6>
                  <p className="text-muted mb-0">
                    <i className="fas fa-map-marker-alt me-1"></i> Salle Pleyel, Paris
                  </p>
                </div>
                <div className="event-status">
                  <span className="badge bg-success">Confirmé</span>
                </div>
              </div>
              
              <div className="upcoming-event d-flex align-items-center p-3 border-bottom">
                <div className="event-date me-3 text-center">
                  <div className="date-day">22</div>
                  <div className="date-month">Avr</div>
                </div>
                <div className="event-details flex-grow-1">
                  <h6 className="mb-1">Exposition d'Art Moderne</h6>
                  <p className="text-muted mb-0">
                    <i className="fas fa-map-marker-alt me-1"></i> Galerie Lafayette, Paris
                  </p>
                </div>
                <div className="event-status">
                  <span className="badge bg-warning text-dark">En attente</span>
                </div>
              </div>
              
              <div className="upcoming-event d-flex align-items-center p-3">
                <div className="event-date me-3 text-center">
                  <div className="date-day">30</div>
                  <div className="date-month">Avr</div>
                </div>
                <div className="event-details flex-grow-1">
                  <h6 className="mb-1">Conférence Tech</h6>
                  <p className="text-muted mb-0">
                    <i className="fas fa-map-marker-alt me-1"></i> Centre des Congrès, Lyon
                  </p>
                </div>
                <div className="event-status">
                  <span className="badge bg-success">Confirmé</span>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
        
        <Col md={4}>
          <Card>
            <Card.Header className="bg-white">
              <h5 className="mb-0">Activité récente</h5>
            </Card.Header>
            <Card.Body className="p-0">
              <div className="activity-item p-3 border-bottom">
                <div className="d-flex">
                  <div className="activity-icon me-3">
                    <i className="fas fa-ticket-alt text-primary"></i>
                  </div>
                  <div>
                    <p className="mb-1">Nouvelle réservation pour <strong>Concert de Jazz</strong></p>
                    <small className="text-muted">Il y a 2 heures</small>
                  </div>
                </div>
              </div>
              
              <div className="activity-item p-3 border-bottom">
                <div className="d-flex">
                  <div className="activity-icon me-3">
                    <i className="fas fa-calendar-plus text-success"></i>
                  </div>
                  <div>
                    <p className="mb-1">Événement <strong>Exposition d'Art</strong> créé</p>
                    <small className="text-muted">Il y a 5 heures</small>
                  </div>
                </div>
              </div>
              
              <div className="activity-item p-3 border-bottom">
                <div className="d-flex">
                  <div className="activity-icon me-3">
                    <i className="fas fa-comment text-warning"></i>
                  </div>
                  <div>
                    <p className="mb-1">Nouveau message de <strong>Marie Dupont</strong></p>
                    <small className="text-muted">Il y a 1 jour</small>
                  </div>
                </div>
              </div>
              
              <div className="activity-item p-3">
                <div className="d-flex">
                  <div className="activity-icon me-3">
                    <i className="fas fa-euro-sign text-danger"></i>
                  </div>
                  <div>
                    <p className="mb-1">Paiement reçu pour <strong>Conférence Tech</strong></p>
                    <small className="text-muted">Il y a 2 jours</small>
                  </div>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default CpanelDashboard;